<template>
  <h2 style="text-align: center;">Text</h2>
  <form class="card col-md-6 offset-md-3">
    <div class="row p-2">
      <div class="col-md-4">
        <label class="form-text"> Enter text to preview </label>
        <input class="form-control" type="text" v-model="TextToPreview" />
      </div>
      <div class="col-md-2">
        <label class="form-text"> Id font </label>
        <input class="form-control" type="number" v-model="IDFontToPreview" />
      </div>
      <div class="col-md-2">
        <label class="form-text"> Id size of text </label>
        <input
          class="form-control"
          type="number"
          v-model="IDSizeFontToPreview"
        />
      </div>
    </div>
    &nbsp;

    <div class="card" style="height: 200px">
    <TextPreview
      :IDFontToPreview="IDFontToPreview"
      :IDSizeFontToPreview="IDSizeFontToPreview"
      :TextToPreview="TextToPreview"
      :dpi="(180.0/store.allFonts.value[IDFontToPreview].sizes[0].FontHeight) * 254"
      superPos = "normal"
      :layersColors="store.getAllColors()"
      :x="0"
      :y="0"
    >
    </TextPreview>
  </div>
  </form>


</template>

<script>
import { storeToRefs } from "pinia";
import { designerStore } from "@/stores/designerStore";
import TextPreview from "./TextPreview.vue";

export default {
  setup() {
    const store = designerStore();
    const { fontList } = storeToRefs(store);

    return {
      store,
      fontList,
    };
  },
  components: {
    TextPreview,
  },
  data() {
    return {
      TextToPreview: "",
      IDFontToPreview: 1,
      IDSizeFontToPreview: 0,
      previewTextOpen: false,
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
</style>